function smoothGeometry(geometry, mergeVertices) {
  let smoothed = geometry.getAttribute
    ? new THREE.Geometry().fromBufferGeometry(geometry)
    : geometry;
  // smoothed.mergeVertices();
  // smoothed.computeVertexNormals();
  smoothed = new THREE.BufferGeometry().fromGeometry(smoothed);
  if (mergeVertices)
    smoothed = THREE.BufferGeometryUtils.mergeVertices(smoothed);
  //   smoothed.computeBoundingBox();
  return smoothed;
}

function toLegacyGeometry(geometry) {
  let legacy = geometry.getAttribute
    ? new THREE.Geometry().fromBufferGeometry(geometry)
    : geometry;
  
  return legacy;
}

export { smoothGeometry, toLegacyGeometry };
